import React, { Component } from 'react';
import {
    Card,
    Input,
    Table,
    Popover,
    Popconfirm,
    Timeline,
    Icon,
    message,
    Tooltip,
    Button,
    Modal,
    Empty,
    Pagination
} from 'antd';
import {uuid} from "../../../utils";
import "./publishRecord.scss";
import ContentModal from "../components/contentModal";
import time from './images/time.png';
import del from './images/delete.png';
import Scrollbars from 'react-custom-scrollbars';
import BaseComponent from "../../../base/BaseComponent";
import moment from "moment"
import {HEADER_HEIGHT} from "../../../constants";
import noPic from "./images/noPic.jpg"

const { Search } = Input;

class PublishRecord extends BaseComponent {

    columns = [
        {
            title: '发布内容',
            dataIndex: 'name',
            className: 'column1',
            key: 'name',
            // width:'80%',
            ellipsis: true,
            render: (text, record) => (
                <div style={{width:'calc(100% - 64px)'}}>
                    <ContentTd removeStuff={this.removeStuff.bind(this)} disable={this.state.disable} {...record} />
                </div>
            ),
        },
        // { title: '发布进度',
        //     dataIndex: 'id',
        //     render: (text, record) => (
        //         <div style={{width:'100%',height:'100%',display:'flex'}}>
        //             <Popover placement="bottom" title={null} content={this.getPopoverContent(record)} >
        //                 <Icon style={{margin:'auto',fontSize:18}} type="calendar" />
        //                 {/*<Button style={{margin:'auto',}} onClick={()=>{this.getPopoverContent(record)}}>发布进度</Button>*/}
        //             </Popover>
        //         </div>
        //     ),
        // },
        {
            title: '操作',
            key: 'action',
            width: 200,
            className: 'column2',
            dataIndex: 'action',
            align: 'center',
            render: (text, record) => {
                let showExplorBtn = record.stuffList.length - 1 !== 0;
                let btnName = record.showStuffList ? "收起" : "展开";
                let fold = record.showStuffList ? true : false
                //let btnName = "查看发布"
                return (
                    // !showExplorBtn ? "" :
                    //     <div className={`other ${fold ? 'fold' : 'expand'}`} style={{
                    //         background: this.themeBgColor;
                    //         fontFamily: 'MicrosoftYaHei-Bold',
                    //         color: '#8792b3',
                    //         fontWeight: 'bolder',
                    //         cursor: 'pointer'
                    //     }} onClick={() => this.updateShowStatus(record)}>{btnName}</div>
                    !showExplorBtn ? "" :
                    <Button
                        type={"primary"}
                        onClick={()=>this.updateShowStatus(record)}
                    >
                        {btnName}
                    </Button>
                )
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            exploreStuff: 1,
            data: [],
            disable: true
        }
    }

    params = {
        page: 1,
        size: 10,
        keywords: "",
        mediaId: this.props.match.params.currentMedia
    };

    componentDidMount() {
        this.initData();
        this.getMediaById()
    }

    render() {
        let tableHeight = window.innerHeight - HEADER_HEIGHT - 30 - 72 - 81;
        let height =  window.innerHeight - HEADER_HEIGHT - 30;
        return (
            <div className="new-group-message" style={{height: height}}>
                <div className="search">
                    <Search placeholder="请输入搜索内容" onSearch={value => this.search(value)} style={{width: '300px'}}/>
                </div>
                <div className="content" style={{padding:0}}>
                    <Scrollbars autoHeight autoHeightMax={tableHeight} autoHide>
                        {
                            this.state.data && this.state.data.length > 0 ?
                                <Table
                                    size={"small"}
                                    rowKey={"id"}
                                    columns={this.columns}
                                    showHeader={false}
                                    pagination={false}
                                    loading={this.state.loading}
                                    dataSource={this.state.data}
                                    className="group-message-table"
                                    rowClassName="group-message-table-select-row"
                                    locale={{emptyText: " "}}
                                /> : <Empty/>
                        }
                    </Scrollbars>
                </div>
                {/*分页栏*/}
                {this.renderPage()}
            </div>
        );
    }


    // 分页栏
    renderPage=()=>{
        let {total,data}=this.state;
        let {params} = this;
        if(!total) return <div style={{height:81}}></div>;
        if(!(data&&data.length>0) && params.page>1) {
            this.pageChange(--params.page, params.size)
        }
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '24px 32px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={params.page}
                    pageSize={params.size}
                    onChange={this.pageChange} //页码改变时回调
                    onShowSizeChange={this.pageChange} //每页条数改变回调
                />
            </div>
        )
    };

    initData = () => {
        this.setState({
            loading: true
        });
        let params = { ...this.params };
        params.tabType = "published";
        this.request({
            url:  '/cm-sites-pms/material/publishMessageList',
            body: params,
            callBack: (res) => {
                this.setState(prevState => {
                    prevState.data = res.data;
                    res.data.map(item => item.showStuffList = false);
                    prevState.loading = false;
                    prevState.total = res.count;
                    return prevState;
                });
            }
        });
    };
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.params.mediaId
            },
            callBack: (res) => {
                let disable = true;
                if(res) {
                    disable = res.disable === 0?false:true
                }
                this.setState({disable});
            }
        })
    };
    /**
     * 组装发布进度信息
     * @param index
     * @returns {*}
     */
    getPopoverContent(record) {
        let timeList = [];
        if (record.publishStatus) {
            if (record.publishStatus.processStatus.length > 0) {
                for (let i = 0; i < record.publishStatus.processStatus.length; i++) {
                    let temp = this.transformTimeLineItem(record.publishStatus.processStatus[i]);
                    timeList.push(this.renderingPublishStatusTimeLineItem(temp));
                }
                return <div><Timeline>
                    {timeList.map(item => item)}
                </Timeline> </div>;
            }
        } else if (record.statusName === '发布' && record.publishStatus && record.publishStatus.status === 2) {
            for (let i = 0; i < record.publishStatus.processStatus.length; i++) {
                let temp = this.transformTimeLineItem(record.publishStatus.processStatus[i]);
                timeList.push(this.renderingPublishStatusTimeLineItem(temp));
            }
            return <div><Timeline>
                {timeList.map(item => item)}
            </Timeline> </div>;
        } else {
            return <div>未查询到发布进度</div>;
        }
    }

    /* 解析发布状态 */
    transformTimeLineItem(str) {
        //模板     "[2019-12-01 17:00:37]开始发布至xx网站/校园新闻",
        //         "[2019-12-01 17:00:38]发布至xx网站/校园新闻成功",
        //         "[2019-12-01 17:00:38]正在发布融媒APP",
        //         "[2019-12-01 17:00:38]发布至融媒APP成功"
        let item = {};
        if (str.indexOf("[") > -1 && str.indexOf("]") > -1) {
            item.time = str.substring(str.indexOf("[") + 1, str.indexOf("]") - 1);
            item.content = str.substring(str.indexOf("]") + 1);
            if (str.indexOf("开始") === str.indexOf("]") + 1) {
                item.type = "start";
            } else if (str.indexOf("正在") === str.indexOf("]") + 1) {
                item.type = "doing";
            } else if (str.indexOf("成功") === str.length - 2) {
                item.type = "ok";
            } else if (str.indexOf("失败") > -1) {
                item.type = "error";
            }
        } else {
            item.type = "none";
            item.time = "";
            item.content = str;
        }
        return item;
    }

    /* 渲染发布状态 */
    renderingPublishStatusTimeLineItem(item) {
        if (item.type === "none") {
            return <Timeline.Item>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "start") {
            return <Timeline.Item >
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "doing") {
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "ok") {
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "error") {
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else {
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }
    }

    updateShowStatus = (record) => {
        record.showStuffList = !record.showStuffList;
        this.setState({
            exploreStuff: new Date().getTime(),
        })
    };

    removeStuff = (stuff) => {
        // {materialId:params.materialId,index:params.index - 1}
        // this.search("");
        this.state.data.forEach((material,index) => {
            if(material.id == stuff.id) {
                this.state.data[index].stuffList[stuff.index].status = 0
            }
        });
        this.setState({})
    };

    search = (value) => {
        let data = value;
        this.params.keywords = data ;
        this.params.page = 1;
        this.params.size = 10;
        this.initData();
    };

    pageChange = (page, pageSize) => {
        this.params.page = page;
        if(pageSize != this.params.size) {
            this.params.page = 1;
            this.params.size = pageSize;
        }
        this.initData();
    };
}

class ContentTd extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            stuffList: props.stuffList,
            showStuffList: props.showStuffList,
            contentModalVisible: false,
            materialId: props.id,
            viewStuffId: 0,
            // 当前这条微信图文的详细信息start
            news_item: [],
            create_time:null,
            update_time:null,
            // 当前这条微信图文的详细信息end
        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(this.state.materialId !== nextProps.id) {
            this.state.materialId = nextProps.id;
        }
        this.setState({
            stuffList: nextProps.stuffList,
            showStuffList: nextProps.showStuffList
        })
    }

    render() {
        let summaryStyle = {
            // display: "-webkit-box",
            // overflow: "hidden",
            // textOverflow: "ellipsis",
            // WebkitLineClamp: 2,
            // WebkitBoxOrient: "vertical",
            marginTop: "10px",
            color: '#a4adc8',
            fontSize: '14px',
            textIndex: "2em",

            overflow:'hidden',
            textOverflow:'ellipsis',
            display:'-webkit-box',
            '-webkit-box-orient':'vertical',
            '-webkit-line-clamp':'2',
            wordBreak: 'break-all',
        };
        let updateTime = this.props.updateTime ? moment(this.props.updateTime).format("YYYY-MM-DD HH:mm:ss") : "";
        return (
            <>
                <style>
                    {
                        `
                        .recordTable tr {
                            display: flex;
                            align-items: center;
                        }
                        .recordTable td {
                            display: flex;
                            align-items: center;
                        }
                        `
                    }
                </style>
                <table width={"100%"} height={"100%"} style={{width:"100%"}} className={'recordTable'}>
                    <tbody width={"100%"}  style={{width:"100%"}}>
                        <tr width={'100%'} heihgt={112} style={{width:"100%",height: 112,overflow: "hidden"}}>
                            <td style={{ width: 104, height: 96, minWidth: 80,textAlign: "right" }}>
                                {
                                    this.state.stuffList && this.state.stuffList[0] && this.state.stuffList[0].titlePic ?
                                        <img src={this.state.stuffList[0].titlePic} style={{objectFit:'cover',borderRadius: '5px'}} height={80} width={80}/>
                                        :
                                        <img src={noPic} style={{objectFit:'cover',borderRadius: '5px'}} height={80} width={80}/>
                                }
                            </td>
                            <td
                                style={{
                                    width: 'calc(100% - 344px)',
                                    padding: "10px",
                                    cursor: 'pointer',
                                }}
                                onClick={() => this.viewStuff(0)}
                            >
                                <div>
                                    <div
                                        style={{
                                            fontFamily: 'MicrosoftYaHei-Bold',
                                            fontSize: '15px',
                                            color: '#2a3a6b',
                                            fontWeight: 'bolder',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {this.state.stuffList[0].title}
                                    </div>
                                    <div
                                        style={{
                                            ...summaryStyle,
                                        }}
                                    >
                                        {this.state.stuffList[0].summary}
                                    </div>
                                </div>
                            </td>
                            <td style={{width: 200, minWidth: 200, textAlign: "center" }}>
                                {/*<img src={time} alt="" />*/}
                                <span style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#8792b3', paddingLeft: 10, position: 'relative', bottom: '-2px' }}
                                >
                                    {updateTime}
                                </span>
                            </td>
                            <td style={{width: 64, minWidth: 64,  textAlign: "center" }}>
                                {
                                    this.state.stuffList[0].status === 0 ? '已删除' :
                                        (this.props.disable?"":<Tooltip placement="top" title={"删除"}>
                                            <Popconfirm
                                                placement="bottomRight"
                                                title={<div style={{width: 230}}>删除后用户将无法访问此图文，确定删除？该操作只能删除历史消息中的记录，不能删除已经成功发送到用户的消息。</div>}
                                                onConfirm={() => {
                                                    this.deleteStuff({materialId:this.state.materialId,index:1})
                                                }}
                                                okText="确认" cancelText="取消">
                                                {/* <Icon type="delete" style={{cursor:"pointer"}}/> */}
                                                {/*<img src={del} style={{ cursor: "pointer" }} alt="" />*/}
                                                    <Button type={"link"}>删 除</Button>
                                            </Popconfirm>
                                        </Tooltip>)
                                }
                            </td>
                            {/*<td style={{ width: "10%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>*/}
                            {/*    <div className="view" style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#7c53c9', fontWeight: 'bolder', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }} onClick={() => window.open(`${this.state.stuffList[0].url}`, '_blank')}>*/}
                            {/*        <svg t="1604297739452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3066" width="20" height="20"><path d="M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z" fill="#7c53c9" p-id="3067"></path></svg></div>*/}
                            {/*</td>*/}
                        </tr>
                        {
                            this.state.showStuffList ?
                                this.state.stuffList.map((item, index) => {
                                    if (index > 0) {
                                        return (
                                            <tr width={'100%'} heihgt={112} key={uuid()} style={{ height: 112,overflow: "hidden",borderTop: "1px solid #f4f6fc"}}>
                                                <td width={80} style={{ textAlign: "right"}}>
                                                    {
                                                        item.titlePic  ?
                                                            <img src={item.titlePic} style={{objectFit:'cover',borderRadius: '5px'}} height={64} width={64} />
                                                            :
                                                            <img src={noPic} style={{objectFit:'cover',borderRadius: '5px'}} height={64} width={64} />
                                                    }
                                                </td>
                                                <td style={{width: 'calc(100% - 344px)', padding: "10px", cursor: 'pointer' }}>
                                                    <div>
                                                        <div
                                                            style={{
                                                                fontFamily: 'MicrosoftYaHei-Bold',
                                                                fontSize: '15px',
                                                                color: '#2a3a6b',
                                                                fontWeight: 'bolder',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                            onClick={() => this.viewStuff(index)}
                                                        >
                                                            {item.title}
                                                        </div>
                                                        <div style={{...summaryStyle}}>{item.summary}</div>
                                                    </div>
                                                </td>
                                                <td width={200} style={{ textAlign: "center" }}>
                                                    {/*<img src={time} alt="" />*/}
                                                    <span style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#8792b3', paddingLeft: 10, position: 'relative', bottom: '-2px' }}
                                                    >
                                                        {updateTime}
                                                    </span>
                                                </td>
                                                <td width={65} style={{ textAlign: "center" }}>
                                                    {
                                                        item.status === 0 ? '已删除' :
                                                            (this.props.disable?"":<Tooltip placement="top" title={"删除"}>
                                                                <Popconfirm
                                                                    placement="bottomRight"
                                                                    title={<div style={{width: 230}}>删除后用户将无法访问此图文，确定删除？该操作只能删除历史消息中的记录，不能删除已经成功发送到用户的消息。</div>}
                                                                    onConfirm={() => {
                                                                        this.deleteStuff({materialId:this.state.materialId,index:index+1})
                                                                    }}
                                                                    okText="确认"
                                                                    cancelText="取消"
                                                                >
                                                                    {/* <Icon type="delete" style={{cursor:"pointer"}}/> */}
                                                                    {/*<img src={del} style={{ cursor: "pointer" }} alt="" />*/}

                                                                        <Button type={"link"}>删 除</Button>
                                                                </Popconfirm>
                                                            </Tooltip>)
                                                    }
                                                </td>
                                                {/*<td style={{ width: "10%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>*/}
                                                {/*    <div className="view" style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#7c53c9', fontWeight: 'bolder', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }} onClick={() => window.open(`${item.url}`, '_blank')}>*/}
                                                {/*        <svg t="1604297739452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3066" width="20" height="20"><path d="M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z" fill="#7c53c9" p-id="3067"></path></svg> </div>*/}
                                                {/*</td>*/}
                                            </tr>
                                        );
                                    }
                                }) :
                                <tr><td></td></tr>
                        }
                    </tbody>
                </table>
            </>
        );
    }

    // 删除
    deleteStuff = (params) => {
        this.request({
            url: "/cm-sites-pms/material/delMessage",
            method: "post",
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success('删除成功', 1, () => {
                        // {materialId:this.state.materialId,index:index+1}
                        this.props.removeStuff({
                            id:params.materialId,
                            index:params.index - 1
                        });
                    });
                }
            }
        });
    };

    viewStuff = (i) => {
        return false;
        // const {materialId} = this.state;
        // if (materialId) {
        //     this.request({
        //         url: "/cm-sites-pms/material/getMaterial",
        //         body: {materialId},
        //         callBack: (res) => {
        //             let news_item = res && res.news_item || [];
        //             if (i > -1 && news_item && news_item.length && news_item[i] && news_item[i].url) {
        //                 window.open(`${news_item[i].url}`, '_blank')
        //             } else {
        //                 message.info("数据丢失")
        //             }
        //             // let create_time = null;
        //             // let update_time = null;
        //             // let news_item = [];
        //             // if (res) {
        //             //     create_time = res.create_time || null;
        //             //     update_time = res.update_time || null;
        //             //     news_item = res.news_item || [];
        //             // }
        //             // this.setState({
        //             //     create_time, update_time, news_item
        //             // })
        //         }
        //     })
        // }
    };

    closeModal = () => {
        this.setState({
            contentModalVisible: false
        })
    };
}

export default PublishRecord;